export default {
  // Ensure card header actions are aligned center vertically
  action: {
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 'auto',
  },
};
